import React from 'react';
import Users from './Page';
import { UsersProvider } from 'providers';

export default function Page() {
  return (
    <UsersProvider>
      <Users />
    </UsersProvider>
  );
}
